import React from 'react';
import { Box, Text } from '@front10/base-elements';
import { useTranslation } from '@front10/utils';

export function DisclaimerLink(props: {
  label: string;
  variant?: string;
  containerVariant?: string;
}) {
  const translate = useTranslation();
  return (
    <Box sx={{ variant: props.containerVariant }}>
      <Text
        sx={{ marginTop: '12px', variant: `${props.variant ?? 'text.disclaimer'}` }}
        dangerouslySetInnerHTML={{
          __html: translate(props.label, 'Disclaimer') || ''
        }}
      />
    </Box>
  );
}
